module.exports = __webpack_public_path__ + "img/assembleia.051590f5.png";